import { render, staticRenderFns } from "./scientific-analysis-module.vue?vue&type=template&id=41994632&scoped=true&"
import script from "./scientific-analysis-module.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-module.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-module.scss?vue&type=style&index=0&id=41994632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41994632",
  null
  
)

export default component.exports